package com.milta.feature.settings.presentation

sealed interface WebSettingsNavEvent {
    /** The Organisation was permanently deleted — the caller must log out (the JWT's tenant no
     * longer exists), same treatment as [com.milta.feature.profile.presentation.ProfileNavEvent.AccountDeleted]. */
    data object OrganizationDeleted : WebSettingsNavEvent
}
